import type { ValuesOf } from '@tmapy/types';

import pkg from '../package.json';
import type { EDASState } from './types';
export const VERSION = process.env.REACT_APP_VERSION ?? pkg.version;
export const SET_APP_STATE = 'SET_APP_STATE';
export const PATH_PREFIX = process.env.PUBLIC_URL;

/**
 * Safari does not permit calling history.replaceState more than 100 times per 30 seconds
 */
export const REPLACE_STATE_DEBOUNCE_TIMEOUT = 300;

export const SET_DATA_QUERY = '@edas/SET_DATA_QUERY';
export const RESET_DATA_QUERY = '@edas/RESET_DATA_QUERY';

export const LOAD_DATA_START = '@edas/LOAD_DATA_START';
export const LOAD_DATA_SUCCESS = '@edas/LOAD_DATA_SUCCESS';
export const LOAD_DATA_FAIL = '@edas/LOAD_DATA_FAIL';

export enum QUERY_STATE {
  SUCCESS = 'SUCCESS',
  WAITING = 'WAITING',
  FAIL = 'FAIL',
  EMPTY = 'EMPTY',
}

export const ENDPOINT_APP_DATA = 'getAppData.php';
export const ENDPOINT_CATALOG_DATA = 'getCatalogData.php';
export const ENDPOINT_DETAIL_DATA = 'getDetailData.php';

export type ENDPOINT =
  | typeof ENDPOINT_APP_DATA
  | typeof ENDPOINT_CATALOG_DATA
  | typeof ENDPOINT_DETAIL_DATA;

export const EndpointToRedux: Record<ENDPOINT, keyof EDASState> = {
  [ENDPOINT_APP_DATA]: 'appData',
  [ENDPOINT_CATALOG_DATA]: 'catalogData',
  [ENDPOINT_DETAIL_DATA]: 'detailData',
};

export const EDAS_TYPE = {
  mapApp: 'mapApp',
  dataset: 'dataset',
  app: 'app',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type EDAS_TYPE = ValuesOf<typeof EDAS_TYPE>;

export const EDAS_FILTER = {
  TYPE: 'record_types',
  PUBLIC: 'public',
  LICENCE: 'licence',
  FORMAT: 'format',
  TOPIC: 'topic',
  OPEN_DATA: 'opendata',
  SYSTEM: 'system',
};

export enum RESOURCE_CATEGORY {
  MAP_SERVICE = 'MAP_SERVICE',
  DB_SCHEMA = 'DB_SCHEMA',
  OTHER = 'OTHER',
}
